import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
import { activateAbTestByEvent } from '../../scripts/ab/registry';

// AB test 86c4u3xqb - Exit intent modal
export default (): AlpineComponentTryba => ({
    init() {
        window.addEventListener('show-modal-user-exit', () => {
            activateAbTestByEvent('show-modal-user-exit');
            this.runModalUserExit();
        });
        window.addEventListener('show-modal-after-x-pages-viewed', () => {
            activateAbTestByEvent('show-modal-after-x-pages-viewed');
            this.runModalAfterXPages();
        });
        this.$store.ab.pageViews++;
        window.addEventListener('show-modal-after-x-seconds-on-a-page', () => {
            activateAbTestByEvent('show-modal-after-x-seconds-on-a-page');
            this.runModalAfterXSeconds();
        });
    },
    runModalUserExit() {
        // Lecture unique du localStorage : on ne lit plus à chaque mouvement de souris.
        const exitModalHasBeenClosed = localStorage.getItem('exitModalHasBeenClosed') === 'true';
        this.$store.ab.exitModalHasBeenClosed = exitModalHasBeenClosed;
        if (exitModalHasBeenClosed) {
            return;
        }

        // mouseleave sur <html> ne se déclenche qu'en sortie de la fenêtre,
        // contrairement à mouseout (qui se déclenche à chaque franchissement de bord
        // d'élément et provoquait des dizaines de lectures localStorage avant le clic).
        const onExit = (event: MouseEvent) => {
            if (event.clientY <= 0) {
                this.$store.ab.isUserExiting = true;
                document.documentElement.removeEventListener('mouseleave', onExit);
            }
        };
        document.documentElement.addEventListener('mouseleave', onExit);
    },
    runModalAfterXPages() {
        this.$store.ab.exitModalHasBeenClosed = localStorage.getItem('exitModalHasBeenClosed') === 'true';
        localStorage.setItem('pageViews', this.$store.ab.pageViews.toString());
        if (this.$store.ab.pageViews >= 3 && !this.$store.ab.exitModalHasBeenClosed) {
            this.$store.ab.isUserExiting = true;
        }
    },
    runModalAfterXSeconds() {
        this.$store.ab.exitModalHasBeenClosed = localStorage.getItem('exitModalHasBeenClosed') === 'true';
        setTimeout(() => {
            if (!this.$store.ab.exitModalHasBeenClosed) {
                this.$store.ab.isUserExiting = true;
            }
        }, 25000);
    },
});
